// extracted by mini-css-extract-plugin
export default {"tabBox":"PostSection_tabBox__MUj-q","tabItem":"PostSection_tabItem__Q5Rk8","postsBox":"PostSection_postsBox__3VNCM"};